// NPM Imports
import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import Select from "react-select";

export default class ReactSelect extends PureComponent {
  constructor(props) {
    super(props);
    this.id = `${Math.round(Math.random() * 10) + 1000}`;
  }

  _findType = options => {
    if (options === undefined || options === null) {
      return "empty";
    }
    if (Array.isArray(options)) {
      if (options.length === 0) {
        return "emptyArray";
      }
      if (typeof options[0] === "string") {
        return "arrayOfString";
      }
      return "arrayOfObjects";
    }
    if (typeof options === "object") {
      return "object";
    }
    return "string";
  };

  _mutateOptions = (options, valueKey, labelKey) => {
    const type = this._findType(options);
    const obj = {};
    switch (type) {
      case "string":
        obj.id = this.id;
        obj.value = options;
        obj.label = options;
        return obj;
      case "object":
        obj.id = options.id || this.id;
        obj.value = options[valueKey] || options.value;
        obj.label = options[labelKey] || options[valueKey] || options.value;
        return obj;
      case "arrayOfString": {
        const arrOfStr = options.map(option => {
          const newObj = {};
          newObj.id = this.id;
          newObj.value = option;
          newObj.label = option;
          return newObj;
        });
        return arrOfStr;
      }
      case "arrayOfObjects": {
        const arrOfObj = options.map(option => {
          const newObj = {};
          newObj.id = option.id || this.id;
          newObj.value = option[valueKey] || option.value || option;
          newObj.label =
            option[labelKey] || option[valueKey] || option.value || option;
          return newObj;
        });
        return arrOfObj;
      }
      case "emptyArray":
      case "empty":
        return [];
      default:
        return [];
    }
  };

  _formatValue = (value, valueKey, labelKey) => {
    let obj = {};
    if (value === undefined || value === null) {
      obj = {};
    } else if (Array.isArray(value)) {
      obj = value.map(option => {
        const newObj = {};
        newObj.id = option.id || this.id;
        newObj.value = option[valueKey] || option.value;
        newObj.label = option[labelKey] || option[valueKey] || option.value;
        return newObj;
      });
    } else if (typeof value === "object" && Object.keys(value).length > 0) {
      obj.id = value.id || this.id;
      obj.value = value[valueKey] || value.value;
      obj.label = value[labelKey] || value[valueKey] || value.value;
    } else if (typeof value === "string") {
      obj.id = this.id;
      obj.value = value;
      obj.label = value;
    }
    return obj;
  };

  // _onChange = (selectionOption, options, valueKey) => {
  //   console.debug(options);
  //   // const optionType = this._findType(options);
  //   const selectedOptionType = this._findType(selectionOption);
  //   if (selectedOptionType === "object") {
  //     selectionOption.props = options.find(
  //       item => item[valueKey] === selectionOption.value,
  //     );
  //   }
  //   this.props.onChange(selectionOption);
  // };

  render() {
    const {
      labelKey,
      onChange,
      options,
      value,
      valueKey,
      ...otherProps
    } = this.props;
    return (
      <Select
        onChange={selectionOption => onChange(selectionOption)}
        options={this._mutateOptions(options, valueKey, labelKey)}
        value={this._formatValue(value, valueKey, labelKey)}
        {...otherProps}
        data-test="select"
      />
    );
  }
}

ReactSelect.defaultProps = {
  isSearchable: true,
  labelKey: "",
  value: null,
  valueKey: "",
};

ReactSelect.propTypes = {
  // Props
  isSearchable: PropTypes.bool,
  labelKey: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({}),
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.arrayOf(PropTypes.shape({})),
  ]).isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({}),
    PropTypes.arrayOf(PropTypes.shape({})),
  ]),
  valueKey: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/commonComponents/Select/Select.js